import { render, staticRenderFns } from "./iconTelephone.vue?vue&type=template&id=73975bc4"
import script from "./iconTelephone.vue?vue&type=script&lang=js"
export * from "./iconTelephone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports